export default "__VITE_ASSET__LHJB$9zJ__"